<template>
  <div class="page-frame project-details" v-if="pageData" role="main">
    <div class="container">
      <h1 class="page-title" role="banner">{{pageData.title.rendered}}</h1>
      <div v-html="pageData.content.rendered"></div>

      <section class="gallery-list">
        <ul
          role="grid"
          v-masonry
          transition-duration="0.3s"
          item-selector=".gallery-item"
          v-if="pageData.acf && pageData.acf.gallery"
        >
          <li
            v-for="(galleryItem, index) in pageData.acf.gallery"
            v-bind:key="index"
            class="gallery-item"
            role="row"
            v-masonry-tile
          >
            <v-card role="gridcell" v-bind:elevation="1" class="gallery-card">
              <!-- IMAGE -->

              <v-img
                v-if="galleryItem.content_type === 'image'"
                v-bind:src="galleryItem.image.url"
                v-bind:alt="galleryItem.image.alt"
                aspect-ratio="1.5"
              ></v-img>
              <img
                class="sr-only"
                v-if="galleryItem.content_type === 'image'"
                v-bind:src="galleryItem.image.url"
                v-bind:alt="galleryItem.image.alt"
                />
              <!-- VIDEO -->
              <div class="embed-container" v-if="galleryItem.content_type === 'video'">
                <div v-html="galleryItem.video"></div>
              </div>
              <div class="click-handler" v-on:click="openElementInLightbox(index)"></div>
            </v-card>
          </li>
        </ul>
      </section>
      <light-box-gallery
        v-if="pageData.acf && pageData.acf.gallery"
        ref="gallery"
        v-bind:gallery="pageData.acf.gallery"
        v-bind:contrastMode="contrastMode"
      ></light-box-gallery>
    </div>
  </div>
</template>

<script>
import LightBoxGallery from "../components/LightBoxGallery.vue";
export default {
  name: "Project",
  components: {
    LightBoxGallery
  },
  props: {
    pageData: Object,
    contrastMode: Boolean
  },
  data: () => {
    return {
      galleryComponent: null
    };
  },
  mounted() {
    this.galleryComponent = this.$refs.gallery;
  },
  methods: {
    openElementInLightbox(index) {
      this.galleryComponent.showElement(index);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/_overrides.scss";

ul {
  list-style-type: none;
  padding: 0;
}

.gallery-item {
  padding: 10px;
  width: 33.33%;
  margin-bottom: 10px;
  @media (max-width: nth(nth($breakpoints, 3), 2)) {
    width: 50%;
  }
  @media (max-width: nth(nth($breakpoints, 1), 2)) {
    width: 100%;
  }
}

.gallery-card {
  position: relative;
}

.click-handler {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

::v-deep {
  .embed-container {
    position: relative;
    padding-bottom: 66.666%;
    overflow: hidden;
    max-width: 100%;
    height: auto;
  }

  .embed-container iframe,
  .embed-container object,
  .embed-container embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .wp-block-image {
    display: flex;
    justify-content: center;
    figure {
      display: flex;
      justify-content: center;
    }
    img {
      max-width: 100%;
      height: auto;
    }
  }
  .wp-block-embed__wrapper {
    display: flex;
    justify-content: center;
    iframe {
      max-width: 100%;
    }
  }

  .wp-block-audio {
    display: flex;
    justify-content: center;
  }
}
</style>
